// import React from 'react';
import ResetPasswordRequest from "./ResetPasswordRequest";
import ResetPasswordChallenge from "./ResetPasswordChallenge";

// export default connect(mapStateToProps, mapDispatchToProps)(ResetPasswordPage);
export { ResetPasswordRequest, ResetPasswordChallenge };



// WEBPACK FOOTER //
// ./src/components/UI/ResetPassword/ResetPassword.jsx